/******************** Server connection **********************/
export const mainurl = 'https://ciapi.purpuligo.com/api/v1/';
export const fileurl = "https://ciapi.purpuligo.com/api/v1/";

/******************** Local connection **********************/
// export const mainurl = 'http://localhost:3006/api/v1/';
// export const fileurl = "http://localhost:3006/api/v1/";

